/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 审计日志模块接口</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2026年09月24日</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	//审计日志
	list(params = {}) {
		return Ajax.get('/audit-log', params)
	}
};
